import { OPEN_ALERT, CLOSE_ALERT } from "../constants/action-types-alert";

export const openAlert = (result) => ({ type: OPEN_ALERT, payload: result });
export const closeAlert = () => ({ type: CLOSE_ALERT });
